import React from 'react'
import version from '@/version'
import context from '@/context'

function Version () {
  return (
    <span style={{ position: 'fixed', width: '100%', bottom: 0, left: 0, display: 'flex', justifyContent: 'flex-end', pointerEvents: 'none' }}>
      <span style={{ opacity: 0.3, padding: '2px 8px', fontSize: '.8em' }}>{context.environment + ' - ' + version.version || ''}</span>
    </span>
  )
}

export {
  Version
}



// WEBPACK FOOTER //
// ./src/components/version.js